import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { House, CalendarCheck, AirplaneTilt, FilePdf, UserCircle, SignOut, Files } from "@phosphor-icons/react";

const tabs = [
  { to: "/employee", label: "Home", icon: House, end: true },
  { to: "/employee/attendance", label: "Attendance", icon: CalendarCheck },
  { to: "/employee/leave", label: "Leave", icon: AirplaneTilt },
  { to: "/employee/payslips", label: "Payslips", icon: FilePdf },
  { to: "/employee/documents", label: "Docs", icon: Files },
  { to: "/employee/profile", label: "Profile", icon: UserCircle },
];

export default function EmployeeLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/login"); };

  return (
    <div className="min-h-screen bg-background max-w-3xl mx-auto flex flex-col">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-white/80 border-b border-stone-200 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src="/dcn-logo.jpg" alt="DCN Food and Beverages" className="h-9 w-auto rounded" data-testid="employee-logo" />
          <div className="text-[11px] text-stone-500 uppercase tracking-wide">Employee<br />Portal</div>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm font-semibold text-stone-700 hidden sm:block" data-testid="employee-user-name">{user?.name}</span>
          <button onClick={doLogout} data-testid="employee-logout-button" className="w-10 h-10 flex items-center justify-center rounded-full bg-stone-100 text-stone-600 hover:text-primary transition-colors duration-200">
            <SignOut size={20} />
          </button>
        </div>
      </header>

      <main className="flex-1 p-4 pb-28">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 inset-x-0 z-30 max-w-3xl mx-auto backdrop-blur-xl bg-white/90 border-t border-stone-200 grid grid-cols-6">
        {tabs.map((t) => (
          <NavLink key={t.to} to={t.to} end={t.end} data-testid={`employee-tab-${t.label.toLowerCase()}`}
            className={({ isActive }) => `flex flex-col items-center justify-center gap-0.5 min-h-[56px] pb-safe text-[11px] font-semibold transition-colors duration-200 ${isActive ? "text-primary" : "text-stone-500"}`}>
            {({ isActive }) => (<><t.icon size={22} weight={isActive ? "fill" : "regular"} />{t.label}</>)}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
